import { render, staticRenderFns } from "./LessWorkHourWidget.vue?vue&type=template&id=ad2a3a10&"
import script from "./LessWorkHourWidget.vue?vue&type=script&lang=js&"
export * from "./LessWorkHourWidget.vue?vue&type=script&lang=js&"
import style0 from "./LessWorkHourWidget.vue?vue&type=style&index=0&id=ad2a3a10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports